export default "__VITE_ASSET__D_uvAAR7__"